
import {loadStripe} from '@stripe/stripe-js';
import getStripePublicKey from './getStripePublicKey';

const STRIPE_PUBLIC_KEY = getStripePublicKey();

export let stripe = async () => {
    return await loadStripe(STRIPE_PUBLIC_KEY)
};